import React from 'react'
import {
  Box, List, ListItem, Typography 
} from '@mui/material'

import { ThemeProvider } from '~/theme'

export const Leadership = () => (
  <ThemeProvider mode='dark'>
    <Box
      component='section'
      sx={{
        position: 'relative',
        pt: { xs: 5, tablet: 16 },
        pb: 8,
      }}>
      <Box
        sx={{
          mx: 'auto',
          maxWidth: 1104,
          px: { xs: 8, laptop: 0 },
        }}>
        <Box
          sx={{
            display: 'flex',
            position: 'relative',
            flexDirection: { xs: 'column-reverse', laptop: 'row' },
            justifyContent: 'space-between',
            gap: 2,
          }}>
          <Box
            sx={{
              maxWidth: { laptop: '50%' },
              img: { width: '100%' },
            }}>
            <Box
              component='img'
              src='/images/leadership-group1-2.png'
              alt='leadership-group1'
            />
          </Box>
          <Box>
            <Box sx={{ pl: { xs: 0, laptop: 10 } }}>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: 40, tablet: 48 },
                  lineHeight: 1.25,
                }}>
                Leadership & Investors
              </Typography>
              <Typography sx={{ maxWidth: 384 }}>
                We’re an engineer-led team of data, security, and marketing
                experts.
              </Typography>
            </Box>
            <Box sx={{ my: 4 }}>
              <List
                sx={{
                  p: 0,
                  pl: { laptop: 10 },
                  li: {
                    p: 0,
                    display: 'inline-block',
                    width: 'auto',
                  },
                }}>
                <ListItem
                  sx={{
                    display: 'inline-block',
                    mr: 5.5,
                  }}>
                  <Box
                    component='img'
                    src='/images/s8-capital-logo.svg'
                    alt='S8 Capital'
                    placeholder='tracedSVG'
                  />
                </ListItem>
                <ListItem sx={{ display: 'inline-block' }}>
                  <Box
                    component='img'
                    src='/images/insight-partners-logo.svg'
                    alt='Insight Partners'
                    placeholder='tracedSVG'
                  />
                </ListItem>
                <ListItem sx={{ mt: 2.5 }}>
                  <Box
                    component='img'
                    src='/images/kleiner-logo.svg'
                    alt='Kleiner Perkins'
                    placeholder='tracedSVG'
                  />
                </ListItem>
              </List>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: { xs: 'none', laptop: 'flex' },
            justifyContent: { xs: 'flex-end', laptop: 'center' },
            ml: 'auto',
            mr: 0,
            mt: -25,
          }}>
          <Box
            component='img'
            src='/images/leadership-group2.png'
            alt='leadership-investors'
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            mt: 2,
            flexDirection: { xs: 'column', laptop: 'row' },
            mr: { xs: 8, tablet: 0 },
          }}>
          <Box
            sx={{
              pb: 3.5,
              ml: 0,
            }}>
            <Box>
              <Typography
                sx={{
                  fontSize: { xs: 40, tablet: 50 },
                  fontWeight: 700,
                }}>
                Team
              </Typography>
              <Typography variant='body1' sx={{ maxWidth: 384 }}>
                The RudderStack team is a group of diverse and talented
                individuals from around the world.
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              mb: 5,
              display: { xs: 'block', laptop: 'none' },
            }}>
            <Box
              component='img'
              src='/images/leadership-group2.png'
              alt='leadership-investors'
            />
          </Box>
          <Box
            sx={{
              position: 'relative',
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: { xs: 'row-reverse', laptop: 'row' },
            }}>
            <Box
              sx={{
                mr: 1.5,
                mb: { xs: 1.5, laptop: 0 },
                maxWidth: 330,
              }}>
              <Box
                component='img'
                src='/images/leadership-group3.webp'
                alt='leadership-investors'
              />
            </Box>
            <Box
              sx={{
                mb: { xs: 1.5, laptop: 0 },
                textAlign: 'center',
                img: {
                  display: 'block',
                  width: '100%',
                },
              }}>
              <Box
                component='img'
                src='/images/leadership-group4.webp'
                alt='leadership-investors'
              />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'flex-start', laptop: 'flex-start' },
            img: {
              display: 'block',
              width: '100%',
            },
          }}>
          <Box
            sx={{
              mr: { tablet: 5, laptop: 38 },
              mt: { tablet: '-17%', laptop: -14.25 },
              ml: { tablet: '43%', laptop: 0 },
              maxWidth: { laptop: 450 },
            }}>
            <Box
              component='img'
              src='/images/leadership-group5.webp'
              alt='leadership-investors'
            />
          </Box>
        </Box>
      </Box>
    </Box>
  </ThemeProvider>
)
